import { Outlet } from "react-router-dom";

const StarterLayout = () => {
  return (
    <div className="flex h-screen flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100">
      <Outlet />
    </div>
  );
};

export default StarterLayout;
